import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { Edit as EditIcon, Delete as DeleteIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  addCompetenceType,
  deleteCompetenceType,
  editCompetenceType,
  getCompetenceTypesWithLimit,
  getCompetenceTypesWithoutDispatch,
} from 'shared/services/competenceTypeService';
import { showSnackbarMessage } from 'shared/store/messages/actions';
import { getTableRowPerPageFromStorage } from 'shared/utils/localStorage';
import AddSkillForm from '../../../components/AddSkillForm/AddSkillForm';
import CustomDialog from '../../../components/CustomDialog/index';
import ConfirmationDialog from '../../../components/LayoutConfirmationDialog/LayoutConfirmationDialog';
import PageHeader from '../../../components/PageHeader';
import ElementsListAsync from '../../../components/list/ElementsListAsync';
import AdminSkillViewHead from '../AdminSkillView/AdminSkillViewHead';
import AdminCompetenceTypeViewHead from './AdminCompetenceTypeViewHead';

export class AdminCompetenceTypeView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dictionariesCompetenceType: [],
      competenceTypes: [],
      competenceTypesCount: 0,
      order: 'asc',
      orderBy: 'id',
      deleteConfirmationOpened: false,
      openEditDialog: false,
      selectedCompetenceType: {},
      options: {
        limit: 12,
        offset: 0,
      },
      isClicked: false,
      isSubmitting: false,
    };
  }

  handleSorting = async (event, property) => {
    const orderBy = property;
    let order = 'asc';

    if (!orderBy) {
      return;
    }

    if (this.state.orderBy === property && this.state.order === 'asc') {
      order = 'desc';
    }

    await this.setState({ order, orderBy });
    this.handleReloadElements();
  };

  openRemoveDialog = competenceType => {
    this.setState({
      selectedCompetenceType: competenceType,
      deleteConfirmationOpened: true,
    });
  };

  handleRemove = async isOk => {
    if (isOk) {
      await deleteCompetenceType(this.state.selectedCompetenceType.id);
      this.handleReloadElements();
    }
    this.setState({
      deleteConfirmationOpened: false,
    });
  };

  onCloseEditDialog = () => {
    this.setState({
      selectedCompetenceType: null,
      openEditDialog: false,
    });
  };

  onOpenEditDialog = competenceType => {
    this.setState({
      selectedCompetenceType: competenceType,
      openEditDialog: true,
    });
  };

  handleUpdateCompetenceType = async values => {
    this.setState({
      isSubmitting: true,
    });
    const body = {
      name: values.name,
      deName: values.deName,
      enName: values.enName,
      uaName: values.uaName,
      isApproved: values.isApproved,
    };
    if (this.state.selectedCompetenceType) {
      editCompetenceType(this.state.selectedCompetenceType.id, body)
        .then(() => {
          this.onCloseEditDialog();
          this.handleReloadElements();
          this.props.showSnackbarMessage('Zapisano zmiany');
          this.setState({
            isSubmitting: false,
          });
        })
        .catch(error => {
          const { status } = error.response;
          if (status === 409) {
            this.props.showSnackbarMessage(
              'Podany typ kompetencji istnieje w systemie'
            );
          } else {
            this.props.showSnackbarMessage('Błąd podczas zapisu informacji');
          }
          this.setState({
            isSubmitting: false,
          });
        });
    } else {
      addCompetenceType(body)
        .then(() => {
          this.onCloseEditDialog();
          this.handleReloadElements();
          this.props.showSnackbarMessage('Zapisano zmiany');
          this.setState({
            isSubmitting: false,
          });
        })
        .catch(error => {
          const { status } = error.response;
          if (status === 409) {
            this.props.showSnackbarMessage(
              'Podany typ kompetencji istnieje w systemie'
            );
          } else {
            this.props.showSnackbarMessage('Błąd podczas zapisu informacji');
          }
          this.setState({
            isSubmitting: false,
          });
        });
    }
  };

  loadData = async (options = {}) => {
    const { limit, offset, filters } = options || this.state.options;
    const limitToSearch = !limit
      ? getTableRowPerPageFromStorage(this.props.match.url) || 12
      : limit;
    const { order, orderBy } = this.state;
    this.setState({
      isLoading: true,
    });
    if (filters && filters.isApproved) {
      delete filters['isApproved'];
    }
    const params = {
      filters,
      orderBy: {
        [orderBy]: order,
      },
    };

    getCompetenceTypesWithoutDispatch().then(response => {
      const { data } = response;
      this.setState({
        dictionariesCompetenceType: data,
      });
    });

    getCompetenceTypesWithLimit(limitToSearch, offset, params).then(
      response => {
        const { data } = response;
        this.setState({
          competenceTypes: data.data,
          competenceTypesCount: data.count,
        });
      }
    );
    this.setState({
      isLoading: false,
    });
  };

  handleReloadElements = (options = false) => {
    if (options) {
      this.setState({
        options,
      });
    }
    if (!this.props.isLoading) {
      return this.loadData(options || this.state.options);
    } else {
      return null;
    }
  };

  componentWillMount() {
    this.handleReloadElements();
  }

  onOpenAddCompetenceTypeDialog = () => {
    this.setState({
      selectedCompetenceType: null,
      openEditDialog: true,
    });
  };

  getWrapper = ({ content, filtering, pagination }) => {
    const { order, orderBy } = this.state;
    return (
      <Paper>
        <PageHeader title="Lista dostępnych typów kompetencji" />
        <Paper style={{ padding: 20 }} elevation={0}>
          {filtering}
        </Paper>
        <Button
          style={{ margin: '17px' }}
          onClick={() => this.onOpenAddCompetenceTypeDialog()}
          variant="contained"
          color="primary"
        >
          Dodaj typ kompetencji
        </Button>
        <Table>
          <TableHead>
            <AdminCompetenceTypeViewHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleSorting}
            />
          </TableHead>
          <TableBody>{content}</TableBody>
          <TableFooter>
            <AdminSkillViewHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleSorting}
            />
          </TableFooter>
        </Table>
        {pagination}
        <CustomDialog
          title={
            this.state.selectedCompetenceType
              ? 'Edycja typu kompetencji'
              : 'Dodaj typ kompetencji'
          }
          maxWidth={'lg'}
          isOpen={this.state.openEditDialog}
          onCloseDialog={this.onCloseEditDialog}
          body={
            <div
              style={{
                width: '600px',
              }}
            >
              <AddSkillForm
                dictionariesSkills={this.state.dictionariesCompetenceType}
                skill={this.state.selectedCompetenceType}
                handleUpdateSkill={this.handleUpdateCompetenceType}
                isSubmitting={this.state.isSubmitting}
                withApproved={true}
              />
              <Button onClick={this.onCloseEditDialog} color="primary">
                Zamknij
              </Button>
            </div>
          }
        />
        <ConfirmationDialog
          open={this.state.deleteConfirmationOpened}
          titleText="Usuń umiejętność?"
          onClose={this.handleRemove}
          okButtonText="Usuń"
          cancelButtonText="Anuluj"
        >
          Czy na pewno usunąć?
        </ConfirmationDialog>
      </Paper>
    );
  };

  getContent = competenceCategory => {
    return (
      <TableRow hover key={competenceCategory.id}>
        <TableCell align="right">{competenceCategory.id}</TableCell>
        <TableCell padding="none">{competenceCategory.name}</TableCell>
        <TableCell padding="none">{competenceCategory.enName}</TableCell>
        <TableCell padding="none">{competenceCategory.deName}</TableCell>
        <TableCell padding="none">{competenceCategory.uaName}</TableCell>
        <TableCell padding="none">
          {competenceCategory.isApproved
            ? 'Zaakceptowany'
            : 'Oczekujący na akceptację'}
        </TableCell>
        <TableCell>
          <IconButton
            style={{ padding: 0 }}
            onClick={() => this.onOpenEditDialog(competenceCategory)}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            style={{ padding: 0 }}
            onClick={() => this.openRemoveDialog(competenceCategory)}
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const { competenceTypes, competenceTypesCount } = this.state;
    const filteringOptions = [
      {
        key: 'name',
        type: 'text',
        name: 'Nazwa',
      },
    ];

    return (
      <ElementsListAsync
        storageKey={this.props.match.url}
        rowsPerPage={getTableRowPerPageFromStorage(this.props.storageKey)}
        handleReloadElements={this.handleReloadElements}
        getContent={this.getContent}
        getWrapper={this.getWrapper}
        filteringOptions={filteringOptions}
        elements={competenceTypes || []}
        elementsCount={competenceTypesCount || 0}
        scrollUp={true}
      />
    );
  }
}

const mapDispatchToProps = {
  showSnackbarMessage,
};

AdminCompetenceTypeView.propTypes = {
  order: PropTypes.string,
  orderBy: PropTypes.string,
  showSnackbarMessage: PropTypes.func.isRequired,
};
export default connect(null, mapDispatchToProps)(AdminCompetenceTypeView);
